import realizaReducer, { realizaActions } from './realiza';

export const { Types, Creators } = realizaActions('welfare/');

export default realizaReducer(Types);
